export default {"src":"/_next/static/media/KNSApp.be33ecb3.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};